import "./Government.module.css";
import Header from "@/reusable_sections/Header";
import GovernmentServices from "./sections/GovernmentServices";
import Methodology from "./sections/Methodology";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function GovernmentPage() {
  return <div>
      <Header />
      <GovernmentServices />
      <Methodology />
      <Action />
      <Footer />
    </div>;
}